import {useCommentsAndReviews} from './data/use-comments-and-reviews'
import {ForYouIssueCommentItem} from './issue-comments/ForYouIssueComment'
import {ForYouReviewCommentItem} from './review-comments/ForYouReviewComment'
import {ForYouThreadItem} from './thread-comments/ForYouThreadItem'

export function CommentsAndReviews() {
  const commentsAndReviews = useCommentsAndReviews()

  return (
    <>
      {commentsAndReviews.map(commentOrReview => {
        switch (commentOrReview.type) {
          case 'comment':
            return <ForYouIssueCommentItem key={commentOrReview.data.id} comment={commentOrReview.data} />
          case 'review':
            return (
              <ForYouReviewCommentItem
                key={commentOrReview.data.summary.id}
                reviewSummary={commentOrReview.data.summary}
                threads={commentOrReview.data.threads}
              />
            )
          case 'thread':
            return <ForYouThreadItem key={commentOrReview.data.id} thread={commentOrReview.data} />
        }
      })}
    </>
  )
}
